import { ModifiedCodeDescription, CodeDescriptionSearchData } from './types-store';

export const compareCodeDescriptionIds = (modified: ModifiedCodeDescription, persisted: CodeDescriptionSearchData) =>
  modified.id === persisted.id &&
  !!persisted.codetable && persisted.codetable.v === modified.codetable &&
  !!persisted.language && persisted.language.v === modified.language;

export const getModifiedItem = (modifiedItems: ModifiedCodeDescription[], persistedItem: CodeDescriptionSearchData) =>
  !modifiedItems || !persistedItem
    ? undefined
    : modifiedItems.find(
      modifiedItem => compareCodeDescriptionIds(modifiedItem, persistedItem)
    );

export const findModifiedItem = (modifiedItems: ModifiedCodeDescription[], modifiedItem: ModifiedCodeDescription) =>
  !modifiedItems || !modifiedItem
    ? undefined
    : modifiedItems.find(item =>
      item.id === modifiedItem.id &&
      item.codetable === modifiedItem.codetable &&
      item.language === modifiedItem.language
    );

export const getPersistedItem = (persistedItems: CodeDescriptionSearchData[], modifiedItem: ModifiedCodeDescription) =>
  !persistedItems || !modifiedItem
    ? undefined
    : persistedItems.find(
      persistedItem => compareCodeDescriptionIds(modifiedItem, persistedItem)
    );

export const compareValue = (persistedItems: CodeDescriptionSearchData, modifiedItem: ModifiedCodeDescription): boolean =>
  modifiedItem?.description === persistedItems?.description &&
  modifiedItem?.longDescription === persistedItems?.longDescription;

export const updatePersistedValue = (
  persistedItems: CodeDescriptionSearchData,
  modifiedItem: ModifiedCodeDescription
): CodeDescriptionSearchData =>
  modifiedItem
    ? {
      ...(persistedItems || {} as CodeDescriptionSearchData),
      description: modifiedItem.description?.trim(),
      ...(modifiedItem.longDescription !== undefined && { longDescription: modifiedItem.longDescription?.trim() })
    }
    : persistedItems;
